import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=0ea3b2da&scoped=true&"
var script = {}
import style0 from "./Star.vue?vue&type=style&index=0&id=0ea3b2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea3b2da",
  null
  
)

export default component.exports